"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("../../../_Core/Icons");
var Icons_2 = require("../../../Icons");
var Localization_1 = require("../../../Localization");
var NavButtons_styles_1 = require("./NavButtons.styles");
var NavigationButton = function (_a) {
    var Caption = _a.Caption, IsSelected = _a.IsSelected, ButtonIcon = _a.ButtonIcon, OnClick = _a.OnClick, IsFirst = _a.IsFirst, IsLast = _a.IsLast;
    return React.createElement(React.Fragment, null,
        React.createElement(NavButtons_styles_1.NavButton, { "aria-selected": IsSelected, IsFirst: IsFirst, IsLast: IsLast, IsSelected: IsSelected, onClick: OnClick, role: "tab" },
            React.createElement(Icons_2.Icon, { Icon: ButtonIcon }),
            React.createElement(NavButtons_styles_1.NavButtonCaption, null, Caption)));
};
exports.default = (function (_a) {
    var OnButtonClick = _a.OnButtonClick, CurrentType = _a.CurrentType;
    var handleButtonClick = function (type) {
        if (CurrentType !== type) {
            OnButtonClick(type);
        }
    };
    return (React.createElement("nav", null,
        React.createElement(NavButtons_styles_1.ButtonWrapper, { role: "tablist" },
            React.createElement(NavigationButton, { ButtonIcon: Icons_1.Icons.Plus, Caption: Localization_1.strings.UploadAvatar_Action_UploadPhoto, IsFirst: true, IsSelected: CurrentType === "UploadPhoto", OnClick: function () { return handleButtonClick("UploadPhoto"); } }),
            React.createElement(NavigationButton, { ButtonIcon: Icons_1.Icons.Camera, Caption: Localization_1.strings.UploadAvatar_Action_UseCamera, IsLast: true, IsSelected: CurrentType === "TakePhoto", OnClick: function () { return handleButtonClick("TakePhoto"); } }))));
});
